"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialEnv = void 0;
const core_1 = require("generic-parser/lib/core");
const _sentenceChildren_1 = require("./rules/$sentenceChildren");
const initialEnv = (initialEnvOptions) => {
    const { options, baseOffset = 0 } = initialEnvOptions;
    const offsetToPos = (0, core_1.getMemorizedStringOffsetToPos)();
    const state = {
        parenthesesDepth: 0,
        maxOffsetMatchFail: null,
        maxOffsetMatchContext: null,
    };
    return {
        currentIndentDepth: 0,
        offsetToPos,
        registerCurrentRangeTarget: () => { },
        options: {
            reParenthesesInlineTextChars: (0, _sentenceChildren_1.makeReParenthesesInlineTextChars)(""),
            reOutsideParenthesesTextChars: (0, _sentenceChildren_1.makeReOutsideParenthesesTextChars)(""),
            rePeriodSentenceTextChars: (0, _sentenceChildren_1.makeRePeriodSentenceTextChars)(""),
            ...options,
        },
        state,
        baseOffset,
    };
};
exports.initialEnv = initialEnv;
//# sourceMappingURL=env.js.map